import { v4 as uuidv4 } from 'uuid';

export const updateRecords = async (sql, bindings) => {

    const response = await runCall('update_records', sql, bindings)
    
    if (response.success) {
        return response.data
    }
    
    return response
}


export const getRecords = async (sql, bindings) => {

    const response = await runCall('get_records', sql, bindings)
    // console.log('response', response)
    if (response.success) {
        return response.data.records
    }
    return response
}

export const insertRecords = async (sql, bindings) => {

    const response = await runCall('insert_records', sql, bindings)
    
    if (response.success) {
        return response.data
    }
    return response
}

export const deleteRecords = async (sql, bindings) => {

    const response = await runCall('delete_records', sql, bindings)
    
    if (response.success) {
        return response.data
    }
    return response
}

const runCall = async (endpoint, sql, bindings) => {

    const query = {
        sql: sql,
        bindings: bindings
    }

    const response = await fetch(`https://opexapi.opex.co.uk/${endpoint}`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_OPEX_API_KEY
        },
        body: JSON.stringify({ query })
      });

    return response.json()
}

export const buildQuery = (data) => {

    const keys = Object.keys(data).filter(key => data[key] !== undefined && data[key] !== null);
    const setClause = keys.map(key => `${key} = ?`).join(', ');
    const andClause = keys.map(key => `${key} = ?`).join(' AND ');
    const params = [...keys.map(key => data[key])];

    return {
        setClause: setClause,
        andClause: andClause,
        params: params
    }
}

export const sendgridEmail = async (templateId, toEmail, fromEmail, templateData) => {

    const response = await fetch(`https://opexapi.opex.co.uk/send_mail`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_OPEX_API_KEY
        },
        body: JSON.stringify({ templateId, toEmail, fromEmail, templateData })
      });

    return response.json()
}

export const processEmails = async (campaignKey) => {
    
    const response = await fetch(`https://opexapi.opex.co.uk/process_emails`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_OPEX_API_KEY
        },
        body: JSON.stringify({ campaignKey })
      });

    return response.json()
}

export const sendVerification = async (toEmail, code) => {

    console.log('sending verification code', toEmail, code)

    const response = await fetch(`https://opexapi.opex.co.uk/send_verification_code`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_OPEX_API_KEY
        },
        body: JSON.stringify({ toEmail, code })
      });

    console.log('response', response)

    return response.json()
}

export const geoCoder = async (lat, lng) => {

    console.log('geocoding', lat, lng)

    const response = await fetch(`https://opexapi.opex.co.uk/geocoder`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_OPEX_API_KEY
        },
        body: JSON.stringify({ lat, lng })
      });

    console.log('response', response)

    return response.json()
}

export const getFreshdeskTickets = async (reference) => {
    const response = await fetch(`https://opexapi.opex.co.uk/freshdesk`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_OPEX_API_KEY
      },
      body: JSON.stringify({ reference })
    });
  
    let data = await response.json();
    return data.data.tickets.results
}

export const getFreshdeskConversations = async (ticketNumber) => {
    const response = await fetch(`https://opexapi.opex.co.uk/freshdesk_conversations`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_OPEX_API_KEY
      },
      body: JSON.stringify({ ticketNumber })
    });
  
    let data = await response.json();
    return data.data.conversations;
}

export const generateKey = () => {

    return uuidv4()
}
